import { BaseConstants } from '@app/core.module';

export class LoginConstants extends BaseConstants {
    public static apiEndPoints = {
        login: 'oauth/token'
    };

    public static Messages = {
        'InvalidCredentials': 'Invalid User Name or Password',
        'Error': 'An error occured, Please contact with Adminstrator'
    };
}
